import ShipmentsPage from '../components/ShipmentsPage';

const ShipmentsSummary = () => <ShipmentsPage viewMode='resumen' />;

export default ShipmentsSummary;
